import firebase from "firebase/app";
import "firebase/messaging";
import "firebase/database";

const initializedFirebaseApp = firebase.initializeApp({
  // Project Settings => Add Firebase to your web app
  apiKey: "AIzaSyBD0yV9gGNEggnerKskqbBVwnuzAI2TQNs",
  authDomain: "corona-react-ba.firebaseapp.com",
  projectId: "corona-react-ba",
  storageBucket: "corona-react-ba.appspot.com",
  messagingSenderId: "137748613933",
  appId: "1:137748613933:web:54ae0efac3c687a171e1a4",
});

function initializeMessaging() {
  if (firebase.messaging.isSupported()) {
    const messaging = initializedFirebaseApp.messaging();
  
    messaging
      .getToken({
        vapidKey:
          "BGOsd9WlA1cFjpZW0kjbUQqKbk7n7_6cUxaii1FbqiURkTPyPEED-mecyWaHWxgDs_q-fH6kWNOHyQCxwoheeTc",
      })
      .then((currentToken) => {
        if (currentToken) {
          pushToken(currentToken);
        } else {
          console.log(
            "No registration token available. Request permission to generate one."
          );
  
          Notification.requestPermission((status) => {
            console.log("Notification permission status:", status);
            if (status === "granted") {
              console.log("Permission granted.");
              pushToken(currentToken);
            } else {
              alert("Permission denied.");
            }
          });
        }
      })
      .catch((err) => {
        console.log("An error occurred while retrieving token. ", err);
      });
    return messaging;
  }
}

function pushToken(token) {
  const database = initializedFirebaseApp.database();

  database
  .ref("token")
  .push(token)
  .catch((err) => {
    console.log(err);
    alert("Das hat nicht funktioniert.");
  });
}

export { initializeMessaging };